var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipise1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 5,
    viewBox: "0 0 21 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9016,
    cy: 2.8,
    r: 2.2,
    transform: "rotate(-180 17.9016 2.8)",
    fill: "#888B94"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2014,
    cy: 2.8,
    r: 2.2,
    transform: "rotate(-180 10.2014 2.8)",
    fill: "#888B94"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.50215,
    cy: 2.8,
    r: 2.2,
    transform: "rotate(-180 2.50215 2.8)",
    fill: "#888B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipise1);
export default __webpack_public_path__ + "static/media/ellipise1.2644ac8958f610e300be97194ec4e361.svg";
export { ForwardRef as ReactComponent };